import { observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { useUIStore } from 'Modules/ui/index.store';
import React, { useCallback } from 'react';
import { ScrollArea } from '~/lib/ui/scroll-area';
import { SidebarContent, SidebarHeader } from '~/lib/ui/sidebar';
import { cn } from '~/lib/utils';
import { ContactDetailsHeader } from './components/ContactDetailsHeader';
import { ContactDetailsInfo } from './components/ContactDetailsInfo';
import { ContactDetailsNotes } from './components/ContactDetailsNotes';
import { ContactDetailsSource } from './components/ContactDetailsSource';
import { useReactiveContact } from './hooks/useReactiveContact';
import { ContactDetailsSidebarProps } from './index.types';

export const ContactDetailsSidebar = observer(
  (props: ContactDetailsSidebarProps) => {
    const { resetEntitySidePanel } = useUIStore();

    const handleClosePanel = useCallback(() => {
      resetEntitySidePanel();
    }, [resetEntitySidePanel]);

    // Get reactive contact from MobX store
    const reactiveContact = useReactiveContact(props.contact);

    if (!reactiveContact) {
      return null;
    }

    return (
      <ScrollArea className={cn('h-full pb-3.5', { hidden: props.hidden })}>
        <SidebarHeader>
          <ContactDetailsHeader
            contact={reactiveContact}
            goBack={props.goBack}
            closePanel={props.closePanel ?? handleClosePanel}
          />
        </SidebarHeader>
        <SidebarContent>
          <ContactDetailsInfo
            contact={reactiveContact}
            openContactDetails={props.openContactDetails}
          />

          {reactiveContact instanceof ContactModelV2 &&
            reactiveContact.source === 'Nylas' && (
              <ContactDetailsSource contact={reactiveContact} showSeparator />
            )}

          {reactiveContact instanceof ContactModelV2 &&
            reactiveContact.notes && (
              <ContactDetailsNotes contact={reactiveContact} showSeparator />
            )}
        </SidebarContent>
      </ScrollArea>
    );
  }
);
